import React, { useState } from "react";

const ViewCustomArtRequest = ({ handleClose }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    <>
      <div className="text-left d-flex justify-content-between align-items-center">
        <p className="mb-0 artwork-details text-left">Request View</p>

        <img
          src="../../images/svg/closeIconDialog.svg"
          className="details-cross"
          alt="Close"
          onClick={handleClose}
          style={{ cursor: "pointer" }}
        />
      </div>
      <hr />
      <div className="">
        <p className="artist-name">Name</p>
        <p className="artist-name1-view">Alice Johnson</p>
      </div>

      <div className="row">
        <div className="col-md-5">
          <p className="artist-name">Phone Number</p>
          <p className="artist-name1-view">+1-951-239-0523</p>
        </div>
        <div className="col-md-5">
          <p className="artist-name">Email</p>
          <p className="artist-name1-view">alice@gmail.com</p>
        </div>
      </div>
      <div className="">
        <p className="artist-name">Address</p>
        <p className="artist-name1-view">
          123 Main Street, Apt 4BLos Angeles, CA 91234
        </p>
      </div>
      <div className="row">
        <div className="col-md-3">
          <p className="artist-name">Country</p>
          <p className="artist-name1-view">United State</p>
        </div>
        <div className="col-md-3">
          <p className="artist-name">State</p>
          <p className="artist-name1-view">California</p>
        </div>
        <div className="col-md-3">
          <p className="artist-name">City</p>
          <p className="artist-name1-view">San Francisco</p>
        </div>
        <div className="col-md-3">
          <p className="artist-name">Zip</p>
          <p className="artist-name1-view">91234</p>
        </div>
        <div className="">
          <p className="artist-name">Artwork Details</p>
          <p className="artist-name1-view">
            A captivating artwork description should grab the viewer's
            attention, delve into the visual elements, provide context, and
            evoke an emotional response. 
          </p>
        </div>
        <div className="d-flex scrollar-images">
          <div>
            <img src="../../images/svg/view-1.svg" />
          </div>
          <div>
            <img src="../../images/svg/view-2.svg" />
          </div>
          <div>
            <img src="../../images/svg/view-3.svg" />
          </div>
          <div>
            <img src="../../images/svg/view-4.svg" />
          </div>
          <div>
            <img src="../../images/svg/view-5.svg" />
          </div>
        </div>
        <div className="mt-4">
          <p className="artwork-details">Payment Details</p>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">Time to fulfillment</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">05 Days</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">Start Date</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">24 July 2025</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">End Date</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">29 July 2025</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">Total Amount</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">$500</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">50% Before Work Begins</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">$250</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <p className="artist-name">50% Delivery/Work Completion</p>
            </div>
            <div className="col-md-7">
              <p className="artist-name1-view">$250</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewCustomArtRequest;
